import { render, staticRenderFns } from "./DiscipleshipTree.vue?vue&type=template&id=46c83f38&scoped=true&"
import script from "./DiscipleshipTree.vue?vue&type=script&lang=js&"
export * from "./DiscipleshipTree.vue?vue&type=script&lang=js&"
import style0 from "./DiscipleshipTree.vue?vue&type=style&index=0&id=46c83f38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c83f38",
  null
  
)

export default component.exports